export enum projectStatus {
  cart_created = 1,
  request_approve = 2,
  approved = 3,
  changed = 4,
  in_progress = 6,
  completed = 7,
  frozen = 9,
}
